import React, { forwardRef } from 'react';

import DefaultLandingHeader from './DefaultLandingHeader';

function AltLandingHeader(props, ref) {
  const { cta, headertext, siteName, logoLink } = props;
  return (
    <DefaultLandingHeader
      className="header--landingPageAlt"
      cta={cta}
      headertext={headertext}
      siteName={siteName}
      logoLink={logoLink}
      ref={ref}
    />
  );
}

export default forwardRef(AltLandingHeader);
